import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const addNotificationSuccess = () => {
  notification.success({
    message: 'Agent Added Successfully!',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Agent has been Deleted',
  });
};

const deleteNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const updateNotificationSuccess = () => {
  notification.success({
    message: 'Agent has been updated',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const {
  AddBegin,
  AddSuccess,
  AddErr,

  ReadBegin,
  ReadSuccess,
  ReadErr,

  UpdateBegin,
  UpdateSuccess,
  UpdateErr,

  DeleteBegin,
  DeleteSuccess,
  DeleteErr,
} = actions;

const DataSubmit = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddBegin());
      const response = await DataService.gql(QUERY.add(data));
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(AddSuccess(response.data.data));
        addNotificationSuccess();
        callback(true);
      } else {
        await dispatch(AddErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(AddErr('Something went wrong, Unable to create Agent.'));
      addNotificationError('Something went wrong, Unable to create Agent.');
    }
  };
};

const DataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(ReadBegin());
      const query = await DataService.gql(QUERY.all);
      await dispatch(ReadSuccess(query.data.data.allAgents.nodes));
    } catch (err) {
      await dispatch(ReadErr(err));
    }
  };
};

const DataSearch = (searchItem) => {
  return async (dispatch) => {
    try {
      await dispatch(ReadBegin());
      if (searchItem !== '') {
        const query = await DataService.get(`/data/search/${searchItem}`);
        await dispatch(ReadSuccess(query.data.data));
      } else {
        try {
          const query = await DataService.get('/data/all');
          await dispatch(ReadSuccess(query.data.data));
        } catch (err) {
          await dispatch(ReadErr(err));
        }
      }
    } catch (err) {
      await dispatch(ReadErr(err));
    }
  };
};

const DataUpdate = (id, data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(UpdateBegin());
      await DataService.gql(QUERY.update({ id, ...data }));
      await dispatch(UpdateSuccess());
      updateNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(UpdateErr(err));
      updateNotificationError(err);
    }
  };
};

const DataDelete = ({ id, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteBegin());
      const data = await DataService.gql(QUERY.update({ id, isActive: false }));

      await dispatch(DeleteSuccess(data.data));
      await getData();
      deleteNotificationSuccess();
    } catch (err) {
      await dispatch(DeleteErr(err));
      deleteNotificationError(err);
    }
  };
};

export { DataRead, DataSearch, DataSubmit, DataDelete, DataUpdate };
